import { CSSProperties } from "react";
import { Colors } from "../../models/enums";

export const UiButtonVariants = ["sage", "gold", "blue", "rust", "brown"] as const;
export type UiButtonVariant = typeof UiButtonVariants[number];

type CssVarStyle = CSSProperties & Record<string, string>;
export const getVariantVars = (variant: UiButtonVariant): CssVarStyle => {
    switch (variant) {
        case "gold":
            return {
                "--ui-btn-bg-top": Colors.uiBtnGoldTop,
                "--ui-btn-bg-mid": Colors.uiBtnGoldMid,
                "--ui-btn-bg-bot": Colors.uiBtnGoldBottom,
                "--ui-btn-border": Colors.uiBtnGoldBorder,
                "--ui-btn-text": Colors.uiBtnGoldText,
                "--ui-btn-focus": Colors.uiBtnGoldFocus,
            };
        case "blue":
            return {
                "--ui-btn-bg-top": Colors.uiBtnBlueTop,
                "--ui-btn-bg-mid": Colors.uiBtnBlueMid,
                "--ui-btn-bg-bot": Colors.uiBtnBlueBottom,
                "--ui-btn-border": Colors.uiBtnBlueBorder,
                "--ui-btn-text": Colors.uiBtnBlueText,
                "--ui-btn-focus": Colors.uiBtnBlueFocus,
            };
        case "rust":
            return {
                "--ui-btn-bg-top": Colors.uiBtnRustTop,
                "--ui-btn-bg-mid": Colors.uiBtnRustMid,
                "--ui-btn-bg-bot": Colors.uiBtnRustBottom,
                "--ui-btn-border": Colors.uiBtnRustBorder,
                "--ui-btn-text": Colors.uiBtnRustText,
                "--ui-btn-focus": Colors.uiBtnRustFocus,
            };
        case "brown":
            return {
                "--ui-btn-bg-top": Colors.uiBtnBrownTop,
                "--ui-btn-bg-mid": Colors.uiBtnBrownMid,
                "--ui-btn-bg-bot": Colors.uiBtnBrownBottom,
                "--ui-btn-border": Colors.uiBtnBrownBorder,
                "--ui-btn-text": Colors.uiBtnBrownText,
                "--ui-btn-focus": Colors.uiBtnBrownFocus,
            };
        case "sage":
        default:
            return {
                "--ui-btn-bg-top": Colors.uiBtnSageTop,
                "--ui-btn-bg-mid": Colors.uiBtnSageMid,
                "--ui-btn-bg-bot": Colors.uiBtnSageBottom,
                "--ui-btn-border": Colors.uiBtnSageBorder,
                "--ui-btn-text": Colors.uiBtnSageText,
                "--ui-btn-focus": Colors.uiBtnSageFocus,
            };
    }
};

export const getButtonStyle = (disabled?: boolean, width?: string, disabledOpacity: number = 0.5): React.CSSProperties => {
    if (disabled) {
        if (width) {
            return { opacity: disabledOpacity, cursor: "not-allowed", width: width };
        }
        return { opacity: disabledOpacity, cursor: "not-allowed" };
    }

    if (width) {
        return { width: width };
    }

    return {};
};
